import(/* webpackMode: "eager", webpackExports: ["ConsentBanner"] */ "/tmp/8dedccfe3f2db3e/components/consent/ConsentBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/tmp/8dedccfe3f2db3e/components/layout/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/tmp/8dedccfe3f2db3e/components/layout/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollProgress"] */ "/tmp/8dedccfe3f2db3e/components/layout/ScrollProgress.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollToTop"] */ "/tmp/8dedccfe3f2db3e/components/layout/ScrollToTop.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PageTracker"] */ "/tmp/8dedccfe3f2db3e/components/tracking/PageTracker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PreloadImages"] */ "/tmp/8dedccfe3f2db3e/components/ui/PreloadImages.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8dedccfe3f2db3e/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/tmp/8dedccfe3f2db3e/node_modules/next/font/google/target.css?{\"path\":\"app/[locale]/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\",\"preload\":false,\"variable\":\"--font-sans\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/tmp/8dedccfe3f2db3e/styles/globals.css");
